/**
 * Keeps the committed value in an autocomplete's collection. A server-searched picker resets its
 * search on a pick, so its options fall back to the first page; when the pick is not on it,
 * react-aria empties the input and the next blur reads "value set, input empty" as a clear
 * (TAS-3660: Persimmons reverts to Select…). Appended last, so Enter still takes the top result.
 */
export function keepSelectedOption<T>(
  options: readonly T[],
  value: T | null | undefined,
  getKey: (option: T) => React.Key
): T[] {
  if (value == null) return [...options];
  const key = getKey(value);
  return options.some((option) => getKey(option) === key) ? [...options] : [...options, value];
}
